// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"60751403","787":"de43785d","938":"ffdca909"}[chunkId] + ".chunk.js";
};